
/**
 * Helper utility for profile URL handling.
 * Provides utilities for working with profile URLs.
 */

/**
 * Checks if a string is a valid UUID
 * @param str String to check
 * @returns Boolean indicating if the string is a UUID
 */
export const isUuid = (str: string): boolean => {
  const uuidRegex = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;
  return uuidRegex.test(str);
};

/**
 * Gets the preferred profile URL for a user
 * @param id User ID (UUID)
 * @param username_slug Username slug if available
 * @returns The preferred URL path for the profile
 */
export const getProfileUrl = (id?: string, username_slug?: string | null): string => {
  if (username_slug) {
    return `https://world-class.design/u/${username_slug}`;
  }
  if (id) {
    return `https://world-class.design/profile/${id}`;
  }
  return '';
};
